import type { User } from '~/models/user.model';
import {
    ServicesItemsLayoutType,
    ServiceSelectionType
} from '~/types/model.types';
import type { ISelectedServiceVariableValue } from '~/types/server.types';
import type { CXServiceSelectionItemBlock } from '~/components/ClientExperience/OneFlow/models/cx-service-selection-item-block.model';

const ServiceLayoutToItemsPerContainer = {
    [ServicesItemsLayoutType.Rows]: 1,
    [ServicesItemsLayoutType.TwoColumns]: 2,
    [ServicesItemsLayoutType.ThreeColumns]: 3
};

export const itemsPerContainer = (servicesLayout: ServicesItemsLayoutType) =>
    ServiceLayoutToItemsPerContainer[servicesLayout] || 3;

export function getBannerDefaultText(
    selectionType: ServiceSelectionType,
    isSessionSelectionBlock: boolean
) {
    if (isSessionSelectionBlock) {
        return 'Select 1 service with session.';
    }

    let primaryText;
    switch (selectionType) {
        case ServiceSelectionType.Multiple:
            primaryText = 'Select one or more services below';
            break;
        case ServiceSelectionType.One:
            primaryText = 'Select a service below';
            break;
        default:
            primaryText = '';
    }
    return primaryText;
}
interface IGetSelectedServicesProps {
    block: CXServiceSelectionItemBlock;
    currUser: Partial<User>;
    selectedServices: ISelectedServiceVariableValue[];
    selectionType: ServiceSelectionType;
}
export function getSelectedServices({
    block,
    currUser,
    selectedServices = [],
    selectionType
}: IGetSelectedServicesProps) {
    const isSingleSelection = selectionType === ServiceSelectionType.One;

    const currService = {
        service_item_block_id: block.block_id,
        user_id: currUser?._id
    };

    const isSelected = !!selectedServices.find(
        service =>
            service.service_item_block_id === currService.service_item_block_id
    );

    let newSelectedServices;
    // Was current service already selected - unselect it
    if (isSelected) {
        newSelectedServices = selectedServices.filter(
            service =>
                service.service_item_block_id !==
                currService.service_item_block_id
        );
        // was unselected - select it
    } else if (isSingleSelection) {
        newSelectedServices = [currService];
    } else {
        newSelectedServices = [...selectedServices, currService];
    }

    return newSelectedServices;
}

export const SERVICE_SELECTION_TYPES = {
    [ServiceSelectionType.One]: 'Single selection',
    [ServiceSelectionType.Multiple]: 'Multiple selection',
    [ServiceSelectionType.NoSelection]: 'View only',
    CustomQuantityState: {
        [ServiceSelectionType.One]: 'Single selection with quantity selection',
        [ServiceSelectionType.Multiple]:
            'Multiple selection with quantity selection',
        [ServiceSelectionType.NoSelection]: 'Quantity selection only'
    }
};
